import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import AppRouter from './app/router'
import { assertEnvironmentIsUsable } from './lib/env'
import './ui/tokens.css'

// Fail loudly at startup rather than serving a backend-less production build.
// During M1 to M3 this is a no-op, because the environment is 'local'.
assertEnvironmentIsUsable()

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Root element #root was not found in index.html.')
}

createRoot(container).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
)
